import { RouteDefinition } from 'src/stores/RouterStore/RouterStore.types';

export const filterMenuItems = (
    routes: RouteDefinition[],
): RouteDefinition[] => {
    return routes
        .filter((route) => route.menuTitle)
        .filter((route) => !route.unavailable)
        .filter((route) => !route.menuHide);
};

/**
 * A route/feature is unavailable when ANY of the given flags is truthy —
 * typically `[UserStore.canNot.view.<feature>, featureList.<feature>.unavailable]`.
 * So a section is closed if the role forbids `view` OR its kill-switch is on.
 */
export const ifFeatureUnavailable = (permissions: boolean[]) => {
    return permissions.some((permission) => Boolean(permission));
};
